export default {
    button: 'el-button',
    icon: 'i',
    slider: 'el-slider',
    rate: 'el-rate',
    upload: 'fc-elm-upload',
    cascader: 'el-cascader',
    colorPicker: 'el-color-picker',
    timePicker: 'el-time-picker',
    datePicker: 'el-date-picker',
    'switch': 'el-switch',
    select: 'fc-elm-select',
    checkbox: 'fc-elm-checkbox',
    radio: 'fc-elm-radio',
    inputNumber: 'el-input-number',
    input: 'el-input',
    formItem: 'el-form-Item',
    form: 'el-form',
    frame: 'fc-elm-frame',
    col: 'el-col',
    row: 'el-row',
    tree: 'fc-elm-tree',
    autoComplete: 'el-autocomplete',
    group: 'fc-elm-group',
}
